import React, { useContext } from "react";
import { ConfirmDialog, useNotifications } from "sprint-common-web";

import { useCloudFileApi } from "../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { CloudFileListingContext } from "../CloudFileListingContext";

interface RemoveCloudFileButtonDialogProps {
    itemId: string;
    onClose(): void;
    isOpen: boolean;
}

export const RemoveCloudFileButtonDialog = ({
    itemId,
    isOpen,
    onClose
}: RemoveCloudFileButtonDialogProps): JSX.Element => {
    const { abandonCloudFile } = useCloudFileApi();

    const { abandonItem } = useContext(CloudFileListingContext);
    const { success, error } = useNotifications();

    const remove = async () => {
        const response = await abandonCloudFile({ cloudFileId: itemId });

        if (response.isValid) {
            abandonItem(itemId);
            success("Cloud file removed succesfully");
        } else {
            error(response.failures[0].message);
        }

        onClose();
    };

    return (
        <>
            <ConfirmDialog
                title="Remove file"
                text="Are you sure you want to remove this file? This action is irreversible."
                hidden={!isOpen}
                confirm={{ onClick: remove }}
                cancel={{ onClick: onClose }}
            />
        </>
    );
};
